module.exports = __webpack_public_path__ + "static/media/ratingIcon1.f852bd4f.svg";